// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Highlights24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Highlights24: FC<Highlights24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="m21.3 18.7-3-3 1.4-1.4 3 3-1.4 1.4Zm-3.6-12-1.4-1.4 3-3 1.4 1.4-3 3Zm-11.4 0-3-3 1.4-1.4 3 3-1.4 1.4Zm-3.6 12-1.4-1.4 3-3 1.4 1.4-3 3Zm6.15-1.875 3.15-1.9 3.15 1.925-.825-3.6 2.775-2.4-3.65-.325-1.45-3.4-1.45 3.375-3.65.325 2.775 2.425-.825 3.575ZM5.825 21l1.625-7.025L2 9.25l7.2-.625L12 2l2.8 6.625 7.2.625-5.45 4.725L18.175 21 12 17.275 5.825 21Z" />
        </svg>
    );
};

export default Highlights24;
